import CurrencySelector from './CurrencySelector'

export default CurrencySelector